import * as _utils from './_utils';

const dev: () => Env = () => {
  const envcode: Envcode = 'dev';

  return {
    NAME: '開発環境',
    COGNITO_REGION: 'us-west-2',
    COGNITO_USER_POOL_ID: 'us-west-2_s3K43D3Yp',
    COGNITO_CLIENT_ID: '7vjgap748l19gmiacg7dmr8331',
    COGNITO_REDIRECT_URI: 'https://dev.anpichecker.com/signin',
    COGNITO_DOMAIN: 'https://tf-an-dev.auth.us-west-2.amazoncognito.com',
    API_ENDPOINT: 'https://stg.api.anpichecker.com/dev',
    ENVCODE: envcode,
    TITLE: _utils.getName(envcode),
    STRIPE_PK: 'pk_test_aLCDECowCWXrI6io12XOoD1Y00ZQdcuR1j',
    RECAPTCHA_SITE_KEY: '6LeA_uwUAAAAAJRa8iDis4Ql9wjrZzzO_uxyY7ED',
  };
};

export default dev();
